/* Sticky add-to-cart bar.
   It mirrors the selected bundle tier and delegates the actual click to the
   real submit button, so there is only ever one add-to-cart path. */
(function () {
  function setup(bar) {
    if (bar.dataset.aelooReady === '1') return;
    var scope = document;
    var realBtn = scope.querySelector('.product-form__submit');
    if (!realBtn) return;
    bar.dataset.aelooReady = '1';

    /* position:fixed resolves against the viewport only while no ancestor has
       a transform. Dawn puts `scroll-trigger animate--slide-in` (a translateY)
       on .product__info-wrapper, which turns it into the containing block and
       traps the bar inside the panel. Reparent to <body> to escape it. */
    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }

    var prices = bar.querySelector('[data-sticky-prices]');
    var qtyEl = bar.querySelector('[data-sticky-qty]');
    var addBtn = bar.querySelector('[data-sticky-add]');

    function mirror() {
      var row = scope.querySelector('.aeloo-bundle__input:checked');
      if (row) {
        var label = row.closest('.aeloo-bundle__row');
        var src = label && label.querySelector('.aeloo-bundle__prices');
        if (src && prices) {
          prices.innerHTML = src.innerHTML
            .replace(/aeloo-bundle__was/g, 'aeloo-sticky__was')
            .replace(/aeloo-bundle__now/g, 'aeloo-sticky__now');
        }
        if (qtyEl) {
          var q = parseInt(row.dataset.quantity, 10) || 1;
          qtyEl.textContent = q > 1 ? (qtyEl.dataset.prefix || 'Qty') + ' ' + q : '';
        }
      }
      // Follow the real button's state so a sold-out product cannot be added.
      if (addBtn) {
        var off = realBtn.hasAttribute('disabled');
        addBtn.disabled = off;
        addBtn.textContent = off ? realBtn.innerText.trim() : addBtn.dataset.label || addBtn.textContent;
      }
    }

    if (addBtn) {
      addBtn.dataset.label = addBtn.textContent.trim();
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        realBtn.click();
      });
    }

    /* Visible only while BOTH hold: the real button has scrolled away, and
       the footer has not arrived yet - otherwise the bar would sit on top of
       the footer at the bottom of the page. */
    var buttonGone = false;
    var footerHere = false;

    function paint() {
      bar.classList.toggle('is-visible', buttonGone && !footerHere);
    }

    var io = new IntersectionObserver(
      function (entries) {
        buttonGone = !entries[0].isIntersecting;
        paint();
      },
      { rootMargin: '0px 0px -20px 0px' }
    );
    io.observe(realBtn);

    var footer =
      document.querySelector('.aeloo-footer') ||
      document.querySelector('#shopify-section-footer, .footer');
    if (footer) {
      var footerIo = new IntersectionObserver(
        function (entries) {
          footerHere = entries[0].isIntersecting;
          paint();
        },
        { rootMargin: '0px 0px 0px 0px', threshold: 0 }
      );
      footerIo.observe(footer);
    }

    document.addEventListener('change', mirror);
    new MutationObserver(mirror).observe(realBtn, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
    });
    mirror();
  }

  function init() {
    document.querySelectorAll('[data-aeloo-sticky]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
